import { observable } from 'mobx';

export type PackageLimitTypeJson = {
  id?: number;
  business_days?: number;
  hour?: number;
};

class PackageLimitType {
  @observable
  readonly id?: number | null;

  @observable
  businessDays: number;

  @observable
  hour: number;

  constructor(args: PackageLimitTypeJson) {
    this.id = args.id;
    this.businessDays = typeof args.business_days === 'number' ? args.business_days : 1;
    this.hour = typeof args.hour === 'number' ? args.hour : 15;
  }

  description() {
    return `${this.businessDays}営${this.hour}時`;
  }

  submitParams() {
    return {
      id: this.id,
      business_days: this.businessDays,
      hour: this.hour
    };
  }
}

export default PackageLimitType;
